import { removeFalsyValues } from '@shared/helpers';
/*                                               */
import { log } from '@shared/log.browser.ts';
import type { DresonRuleResolvedEvent } from '@shared/types/Tilelist.ts';
import { createOnExFromServerData } from '@tilelist/application/core/OnExFactory.ts';
import type {
    TileListInitialSession,
    TileListSessionContext,
} from '@tilelist/application/core/TileListInitialSession.ts';
import type { TileListPageLoader } from '@tilelist/application/core/TileListPageLoader.ts';
import type { CacheKeyRefresher } from '@tilelist/application/ports/CacheKeyRefresher.ts';
import type { ClientReloadContextProvider } from '@tilelist/application/ports/ClientReloadContextProvider.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';
import { tileListQueryParamSchema } from './TileListRouteValidation.ts';

export type TileListPageLoadResult = {
    /*                                                */
    page: TileListPageLayout | null;
    /*                                                                                  */
    historic: boolean | undefined;
    /*                                                                            */
    shouldScroll: boolean | undefined;
};

export type TileListPageSession = {
    snapshot: TileListSessionContext;
    onex: OnEx;
    /**
 *
 *
 *
 */
    reload: (event: DresonRuleResolvedEvent, entryRule?: string) => Promise<TileListPageLoadResult>;
};

export type TileListSessionServices = {
    pageLoader: TileListPageLoader;
    reloadContextProvider: ClientReloadContextProvider;
    /*                                                                 */
    cacheKeyRefresher: CacheKeyRefresher;
};

/**
 *
 *
 *
 *
 *
 *
 */
export function createPageSession(
    initialSession: TileListInitialSession,
    services: TileListSessionServices,
): TileListPageSession {
    const snapshot = initialSession.session;
    const onex = createOnExFromServerData(snapshot.onexServerData);

    async function reload(event: DresonRuleResolvedEvent, entryRule?: string): Promise<TileListPageLoadResult> {
        const { rule, page, historic, shouldScroll } = event;

        /*                                                                                 */
        /*                                               */
        const queryParamParseResult = tileListQueryParamSchema.safeParse(removeFalsyValues({ rule, ...page }));

        if (!queryParamParseResult.success) {
            log.error('Invalid query parameters:', queryParamParseResult.error);
            return { page: null, historic: undefined, shouldScroll: undefined };
        }

        const queryParams = queryParamParseResult.data;

        const reloadContext = await services.reloadContextProvider.create(snapshot);

        const pageResult = await services.pageLoader({
            mode: 'reload',
            entryRule,
            ctx: {
                queryParams,
                requestContext: reloadContext,
                onex,
            },
        });

        if (pageResult.state !== 'success') {
            log.error('Failed to load tile list');
            return { page: null, historic, shouldScroll };
        }

        const pageView: TileListPageLayout = pageResult.payload;

        await services.cacheKeyRefresher.refresh();

        return { page: pageView, historic, shouldScroll };
    }

    return { snapshot, onex, reload };
}
